import React from 'react';
import './JourneyToMarsPage.css';

const JourneyToMarsPage = () => {

  return (
    <div className="journeytomars-page">
      <div className="container">
        
        {/* Hero Section */}
        <div className="journeytomars-hero">
          <h1>Journey To Mars</h1>
          <div className="hero-visual">
            <div className="golf-preview">
              <div className="golf-ball">
                <div className="ball">⛳</div>
                <div className="trajectory"></div>
              </div>
              <div className="planet-indicator">
                <span>🌍 → 🪐</span>
              </div>
            </div>
          </div>
        </div>

        {/* Project Overview */}
        <div className="project-section">
          <h2>About Journey To Mars</h2>
          <p>
            Journey To Mars is a 3D golf game created in partnership with Coleman Rhode for a 6-hour hackathon. 
            The prompt was "Journey to Mars," and we took a space golf approach, creating an immersive 3D experience 
            where players navigate from Earth to Mars.
          </p>
          <p>
            Built under extreme time constraints, this project showcases rapid development skills and creative problem-solving 
            in a hackathon environment.
          </p>
          <div className="demo-video">
            <video autoPlay loop muted playsInline>
              <source src="/projects/golf/gameoverview_golf.mp4" type="video/mp4" />
            </video>
          </div>
        </div>

        {/* Technology Stack */}
        <div className="tech-section">
          <h2>Technologies Used</h2>
          <div className="tech-grid">
            <div className="tech-item">
              <div className="tech-icon">⚛️</div>
              <span>React</span>
            </div>
            <div className="tech-item">
              <div className="tech-icon">🎨</div>
              <span>React Three Fiber</span>
            </div>
            <div className="tech-item">
              <div className="tech-icon">🟨</div>
              <span>JavaScript</span>
            </div>
            <div className="tech-item">
              <div className="tech-icon">🌐</div>
              <span>3D Web Graphics</span>
            </div>
          </div>
        </div>

        {/* Key Features */}
        <div className="features-section">
          <h2>Key Features</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🌍</div>
              <h3>Realistic Gravity Physics</h3>
              <p>Advanced physics engine that accurately calculates gravity effects when transitioning from Earth to Mars</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⛳</div>
              <h3>3D Golf Gameplay</h3>
              <p>Immersive 3D golf experience built with React Three Fiber for smooth rendering and interactions</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🚀</div>
              <h3>Space Theme</h3>
              <p>Unique space-themed golf experience that takes players on a journey from Earth to Mars</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Rapid Development</h3>
              <p>Built in just 6 hours for a hackathon, demonstrating fast iteration and teamwork</p>
            </div>
          </div>
        </div>

        {/* Technical Challenges */}
        <div className="challenges-section">
          <h2>Technical Challenges</h2>
          <div className="challenge-list">
            <div className="challenge-item">
              <div className="challenge-number">01</div>
              <div className="challenge-content">
                <h3>Time Constraints</h3>
                <p>With such a strict 6-hour time limit, creating a fully functional 3D golf game required efficient planning and rapid development</p>
              </div>
            </div>
            <div className="challenge-item">
              <div className="challenge-number">02</div>
              <div className="challenge-content">
                <h3>Custom Physics Engine</h3>
                <p>Programming accurate physics calculations for ball bounce and gravity effects, especially when transitioning between different planetary environments</p>
              </div>
            </div>
            <div className="challenge-item">
              <div className="challenge-number">03</div>
              <div className="challenge-content">
                <h3>3D Integration</h3>
                <p>Integrating React Three Fiber for 3D rendering while maintaining smooth performance and realistic physics interactions</p>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default JourneyToMarsPage;
